module.exports = __webpack_public_path__ + "img/presentation-item.b264f214.svg";